import { ThemePreferenceEnum } from '@/bundles/App/enums/ThemePreferenceEnum';

const STORAGE_KEY = 'sc-theme-preference';

const isThemePreference = (value: unknown): value is ThemePreferenceEnum => {
  return Object.values(ThemePreferenceEnum).includes(value as ThemePreferenceEnum);
};

// Per-browser choice: storage can be blocked (private windows, cleared site
// data), in which case the app follows the system setting.
export const readThemePreference = (): ThemePreferenceEnum => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);

    return isThemePreference(stored) ? stored : ThemePreferenceEnum.system;
  } catch {
    return ThemePreferenceEnum.system;
  }
};

export const saveThemePreference = (preference: ThemePreferenceEnum): void => {
  try {
    localStorage.setItem(STORAGE_KEY, preference);
  } catch {
    // Not persisted; the choice still applies for this session.
  }
};
